<nav id="index-navbar-nav" class="navbar navbar-expand-lg navbar-dark py-3 fixed-top animate__animated animate__fadeIn">
    <div class="container align-items-center">

        <!-- LEFT: Brand -->
        <a class="navbar-brand d-flex align-items-center" [routerLink]="['/']" (click)="scrollToSection('index-masterhead-section', $event)">
            <span class="brand-wordmark">Powell Industries</span>
        </a>

        <!-- Mobile Toggle -->
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#index-navbar"
            aria-controls="index-navbar" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <!-- CENTER + RIGHT -->
        <div class="collapse navbar-collapse" id="index-navbar">

            <!-- CENTER: NAV LINKS -->
            @if (includeCenterLinks) {
                <ul class="navbar-nav mx-auto gap-lg-3">
                    @for (navLink of navLinks; track navLink.sectionId) {
                    <li class="nav-item">
                        <a
                            class="nav-link"
                            [class.active]="isActiveSection(navLink.sectionId)"
                            [href]="'#' + navLink.sectionId"
                            (click)="scrollToSection(navLink.sectionId, $event)"
                        >
                            {{ navLink.label }}
                        </a>
                    </li>
                    }
                </ul>
            }

            <!-- RIGHT: AUTH + CTA -->
            <div [class]="includeCenterLinks ? 'd-flex align-items-center gap-2 mt-3 mt-lg-0' : 'd-flex align-items-center gap-2 mt-3 mt-lg-0 ms-auto'">
                <a [href]="environment.portalLinks.login">
                    <button class="btn btn-portal-secondary px-3" [routerLink]="['login']">PI | Portal</button>
                </a>
                <a [href]="environment.portalLinks.registration">
                    <button class="btn btn-portal-primary px-3" [routerLink]="['registration']">Get Started</button>
                </a>
            </div>
        </div>

    </div>
</nav>
